import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NeqDatePickerModel} from '@sharedcommon/model/datepicker.model';
import {
  EntityRawMaterialsDto,
  EntityServiceClient,
  ExportMultiFormatRequestDto,
  ExportRawMaterialCodeDto,
  RawMaterialDto,
  RawMaterialFilterDto,
  RawMaterialService
} from '@sharedcommon/rest/data.restservice';
import {UserService} from '@sharedcommon/services/user.service';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HeaderService} from '@sharedcommon/services/header.service';
import {NeqTableRequest} from '@sharedcommon/components/table/neq-table-request.model';
import {Rights} from '@sharedcommon/util/rights.util';
import {RawmaterialOrSampleStatus} from '@sharedcommon/util/rawmaterial-or-sample-status.utils';
import {ValidationService} from '@sharedcommon/services/validation.service';
import {NeqHasTableComponent} from '@sharedcommon/components/table/neq-has-table.component';
import {ToastService} from '@sharedcommon/services/toast.service';
import {
  NeqRawMaterialsConfirmationPopinComponent
} from '@usercommon/components/rawmaterials/confirmation-popin/rawmaterials-confirmation-popin.component';
import {FunctionUtils} from '@sharedcommon/util/functions.util';
import {NeqDialogService} from '@sharedcommon/services/dialog.service';
import {SubEntityServiceClient} from '@sharedrest/identity.restservice';
import {Constants} from '@sharedcommon/util/constants.util';
import {PrimengTableCols, SortOrderTableEnum} from '@sharedcommon/interfaces/primeng-table-cols';
import {PrimengTableComponent} from '@sharedcommon/components/primeng-table/primeng-table.component';
import {MatDialog} from '@angular/material/dialog';
import {NeqTableData} from '@sharedcommon/model/neq-table-data.model';
import {PrimengTableService} from '@sharedcommon/components/primeng-table/primeng-table.service';
import {EMPTY, lastValueFrom, of, Subject} from 'rxjs';
import {RawmaterialsExportDialogComponent} from '@usercommon/components/rawmaterials/rawmaterials-export-dialog/rawmaterials-export-dialog.component';
import {NeqTableComponent} from '@sharedcommon/components/table/neq-table.component';
import {RawmaterialOrSampleService} from '@usercommon/service/rawmaterial-or-sample.service';
import {CalculationStatusService} from "@usercommon/service/calculation-status.service";
import {
  RawmaterialsImportFullAutoPopin
} from '@usercommon/components/rawmaterials/rawmaterials-import-full-auto-popin/rawmaterials-import-full-auto-popin.component';
import {
  RawmaterialsImportSemiAutoPopinComponent
} from '@usercommon/components/rawmaterials/rawmaterials-import-semi-auto-popin/rawmaterials-import-semi-auto-popin.component';
import {ImportSemiAutoStore, SemiautoImportMode} from '@usercommon/stores/import-semiauto.store';
import {ActionTableEvent} from '@sharedcommon/model/action-table-event.model';
import {catchError, takeUntil} from "rxjs/operators";
import {SharedPagedResponse} from '@sharedcommon/model/shared-paged-response.model';
import { RmOrSampleMultiModificationStore } from '@usercommon/stores/rm-or-sample-multi-modification.store';
import { RawMaterialOrSampleUtil } from '@sharedcommon/util/rawmaterial-or-sample.util';
import { RawMaterialsMultiEditService } from '@usercommon/service/rawmaterials-multi-edit.service';
import { RawmaterialsMultiEditErrorPopinComponent } from '@usercommon/components/rawmaterials/rawmaterials-multi-edit-error-popin/rawmaterials-multi-edit-error-popin.component';
import { SharedSortOrder } from '@sharedcommon/model/shared-sort-order.model';
import { NeqRawmaterialsMultiEditSizeLimitDialogComponent } from '@usercommon/components/rawmaterials/rawmaterials-multi-edit-size-limit-popin/rawmaterials-multi-edit-size-limit.dialog';
import { environment } from '@sharedenvironment';
import { CalculationStatus } from '@sharedcommon/model/calculation-status.model';

@Component({
  selector: 'neq-rawmaterials-list',
  templateUrl: './rawmaterials-list.page.html'
})
export class NeqRawmaterialsListPage extends NeqHasTableComponent<RawMaterialDto> implements OnDestroy, AfterViewInit, OnInit {

  private readonly destroy$ = new Subject();

  @ViewChild(NeqTableComponent) table: NeqTableComponent<any>;

  public showDateFilter = false;
  public date = new NeqDatePickerModel;
  public rawmaterials: RawMaterialDto[];
  public results: string[];
  public calculateRight = [Rights.U_MP_CALCULATE];
  public deleteRight = [Rights.U_MP_DELETE];
  public enableDisableRight = [Rights.U_MP_ENABLE_DISABLE];
  public archiveRight = [Rights.U_MP_ARCHIVE];
  public desarchiveRight = [Rights.U_MP_DESARCHIVE];
  duplicateRight = [ Rights.U_RM_DUP ] ;
  public archiveOrDesarchiveRight = [Rights.U_MP_ARCHIVE, Rights.U_MP_DESARCHIVE];
  fullAutoRmCreate = [ Rights.U_MP_FULLAUTO_IMPORT_CREATE ];
  fullAutoRmModify = [ Rights.U_MP_FULLAUTO_IMPORT_MODIFY ];
  fullAutoRm = [ Rights.U_MP_FULLAUTO_IMPORT_CREATE, Rights.U_MP_FULLAUTO_IMPORT_MODIFY ];
  editMassRm = [ Rights.U_MP_MASS_EDIT ];
  semiAutoRmCreate = [ Rights.U_MP_SEMIAUTO_IMPORT_CREATE ];
  semiAutoRmModify = [ Rights.U_MP_SEMIAUTO_IMPORT_MODIFY ];
  semiAutoRm = [ Rights.U_MP_SEMIAUTO_IMPORT_MODIFY, Rights.U_MP_SEMIAUTO_IMPORT_CREATE ];

  RAW_MAT_LIST_SESSION_ID = 'rawmaterialsList';
  SEMI_AUTO_SESSION_ID = PrimengTableService.returnSemiAutoTableSessionId();

  private jobIdImport: string;

  importAutoCheckInterval: number;

  rmCols: PrimengTableCols[] = [
    {
      field: 'access', header: 'label.common.access', iconHeaderClassName: 'fas fa-lock',
      type: 'lock', tooltipMsgKey: 'lockUserFullName', sortable: false, filterable: false,
      position: 'center'
    },
    { field: 'calculationStatus', header: 'label.user.rawmaterial.calculation-status', iconHeaderClassName: 'fas fa-calculator', type: 'calculationIcon', filterable: false, position: 'left' },
    { field: 'code', header: 'label.common.code', defaultSortOrder: SortOrderTableEnum.asc, defaultSortPosition: 1 },
    { field: 'label', header: 'label.common.label' },
    { field: 'entityLabel', header: 'label.common.entity', sortable: false },
    { field: 'referenceLabel', header: 'label.common.reference' },
    { field: 'referencePredictionModelLabel', header: 'label.common.prediction-model' },
    { field: 'calculationDate', header: 'label.common.last-record', type: 'date' },
    { field: 'calculationBy', header: 'label.common.by' }
  ];

  semiautoImportCols: PrimengTableCols[] = [
    { field: 'lineNumber', header: 'label.user.rawmaterial.header.import.semi-auto.linenumber', defaultSortOrder: SortOrderTableEnum.asc, defaultSortPosition: 1 },
    { field: 'calculationStatus', header: 'rawmaterial.label.calculation-status', iconHeaderClassName: 'fas fa-calculator', type: 'calculationIcon', filterable: false, position: 'left' },
    { field: 'code', header: 'label.common.code' },
    { field: 'label', header: 'label.common.label' },
    { field: 'entityLabel', header: 'label.common.entity', sortable: false },
    { field: 'referenceLabel', header: 'label.common.reference' },
    { field: 'referencePredictionModelLabel', header: 'label.common.prediction-model' },
    { field: 'calculationDate', header: 'label.common.last-record', type: 'date' },
    { field: 'calculationBy', header: 'label.common.by' }
  ];

  advancedSearchFilters: { [key: string]: string };
  private checkedRawMaterials: EntityRawMaterialsDtoExtended[] = [];
  private checkedRawMaterialsForExport: EntityRawMaterialsDtoExtended[] = [];
  private checkedRawMaterialIds: string[] = [];
  private jobId: unknown;
  public displayArchivedRawMat: boolean = false;
  public displayDisabledRawMat: boolean = false;
  public showTable = true;
  private displayWaitingForCalculationRM: boolean = false;
  private checkedMultiModificationRm: RawMaterialDto[] = [];
  private currentSort: SharedSortOrder[];
  importSemiAutoIsOnGoing: boolean = false;

  constructor(
    private readonly entitySubService: SubEntityServiceClient,
    private readonly headerService: HeaderService,
    private readonly entityService: EntityServiceClient,
    private readonly rawMatService: RawMaterialService,
    private readonly userService: UserService,
    private readonly store: RawmaterialOrSampleService,
    private readonly router: Router,
    private readonly translate: TranslateService,
    private readonly route: ActivatedRoute,
    private readonly toastService: ToastService,
    private readonly changeDetector :ChangeDetectorRef,
    private readonly primengTableService: PrimengTableService,
    private readonly dialogService: NeqDialogService,
    private readonly dialogMat: MatDialog,
    validation: ValidationService,
    private readonly importSemiautoStore: ImportSemiAutoStore,
    private readonly rmMultiModificationStore: RmOrSampleMultiModificationStore,
    private readonly rawMaterialsMutiEditService: RawMaterialsMultiEditService) {
    super(validation);
    this.validationService.init();

    userService.getJobId(Constants.JOB_TYPE_IMPORT_RM_FULL_AUTO).subscribe(value => {
      this.jobIdImport = value;
    });
  }

  ngOnInit(): void {
    this.rmMultiModificationStore.stop();
    this.importSemiautoStore.getSemiAutoProcessState()
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        /* Will switch the table to show */
        this.importSemiAutoIsOnGoing = state;
      });

      const savedArchivedState = sessionStorage.getItem('RAW_MAT_ARCHIVED_STATE');
      const savedDisabledState = sessionStorage.getItem('RAW_MAT_DISABLED_STATE');
      this.displayArchivedRawMat = savedArchivedState === 'true';
      this.displayDisabledRawMat = savedDisabledState === 'true';

      // Check for current auto import jobs
      if (this.jobIdImport && this.jobIdImport !== ''){
        this.importFullAutoCheck();
      }
  }

  ngOnDestroy(): void {
    this.destroy$.next(false);
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        this.advancedSearchFilters = {
          levelId: params['levelId'],
          predictionModelId: params['predictionModelId'],
          referenceId: params['referenceId']
        };
        if(this.table){
          this.table.fireRefresh()
        }
      });

    this.primengTableService.actionEvent$.pipe(takeUntil(this.destroy$)).subscribe((action: ActionTableEvent) => {
      if (action) {
        this.treatAction(action);
        this.primengTableService.setActionEvent(null);
      }
    });

    this.primengTableService.selectRowEvent$.pipe(takeUntil(this.destroy$)).subscribe((rows: any[]) => {
      if (rows) {
        this.broadcastSelectedRows(rows);
      }
    });

    this.userService.getJobId(Constants.JOB_TYPE_CALCULATE_BATCH)
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        this.jobId = value;
      });

    this.userService.refreshJobs();
    this.displayWaitingForCalculationRM = false;

    window.onbeforeunload = () => this.ngOnDestroy();
    this.changeDetector.detectChanges() ;
  }

  hasFormModifications(): boolean {
    return false;
  }

  isChecked() {
    return false;
  }

  canExport(): boolean {
    return this.exportEnabled() && this.checkedRawMaterialsForExport.length > 0
      && this.checkedRawMaterials.every(value => FunctionUtils.isDefined(value.rmCodes) && value.rmCodes.length > 0);
  }

  exportEnabled() {
    return this.userService.hasRights([Rights.U_MP_EXPORT]) && this.userService.getEntityDto().rawmatExportEnabled;
  }

  canCalculateBatch() {
    return this.calculateBatchEnabled() && this.checkedRawMaterialIds.length > 0;
  }

  calculateBatchEnabled() {
    return this.userService.hasRights([Rights.U_MP_CALCULATE_BATCH]);
  }

  isRawMaterialExportDisabled(rawmat: RawMaterialDto): boolean {
    return !rawmat.calculationDate && rawmat.calculationStatus != CalculationStatus.WaitingForCalculation
      || rawmat.status !== RawmaterialOrSampleStatus.ENABLED;
  }

  canMultiEdit() {
    return this.checkedRawMaterialIds.length >= 2;
  }

  async navigateToMultiEditPage() {

    // Do not let access to multi edit page if more than multiEditLimit raw materials are selected
    if (this.checkedRawMaterialIds.length >= environment.multiEditLimit){
      this.dialogMat.open(NeqRawmaterialsMultiEditSizeLimitDialogComponent, {
        data: {
          message: this.translate.instant('label.user.rawmaterial.popin.multiEdit.size.limit')
        }
      });
      return;
    }

    let rawMaterialsId = [];
    let rawMaterialsOnErrorStatus = [];
    let rawMaterialsOnErrorLock = [];

    const filter = new RawMaterialFilterDto();
    filter.ids = this.checkedRawMaterialIds;
    filter.page = Constants.ALL_PAGE;
    filter.sort = this.currentSort;

    const rmList = await splittedFetchData(filter, this.checkedRawMaterialIds, this.rawMatService, this.userService.getEntity());

    // Check if selected RM can be edit
    for (let rm of rmList.data) {

      // Check Error
      if (rm?.status != 0) {
        rawMaterialsOnErrorStatus.push(rm);
      } else if (rm.lockDate && RawMaterialOrSampleUtil.isLocked(rm)){
        rawMaterialsOnErrorLock.push(rm);
      } else {
        rawMaterialsId.push(rm.id);
      }
    }

    // Create error message
    if (rawMaterialsOnErrorStatus.length > 0 || rawMaterialsOnErrorLock.length > 0) {
      this.dialogMat.open(RawmaterialsMultiEditErrorPopinComponent, {
        data: {
          rawMaterialsOnErrorStatus: rawMaterialsOnErrorStatus,
          rawMaterialsOnErrorLock: rawMaterialsOnErrorLock
        }
      }).afterClosed().subscribe(res => {
        if (res && rawMaterialsId.length > 0)
          this.lockAndRedirecteMutliEdit(rawMaterialsId);
      });
    } else if (rawMaterialsId.length > 0) {
      this.lockAndRedirecteMutliEdit(rawMaterialsId);
    }
  }

  /**
   * Set lock to raw materials and redircte to multi edit page
   * @param rawMaterialsId
   */
  private async lockAndRedirecteMutliEdit(rawMaterialsId: string[]) {
    // Set lock

    await Promise.all(lockingRawMaterials(rawMaterialsId, true, this.rawMatService, this.userService.getEntity()));

    this.rawMaterialsMutiEditService.rawMaterialsId = rawMaterialsId;
    this.rawMaterialsMutiEditService.currentSort = this.currentSort;
    this.router.navigate(['/app/rawmaterials/multiedit']);
  }

  private getCheckedRawMaterialsByEntityCodeForCalcBatch(rawmat: RawMaterialDto): EntityRawMaterialsDtoExtended {
    return this.checkedRawMaterials.find(value => value.entityCode === rawmat.entity.identifier);
  }

  private getCheckedRawMaterialsByEntityCodeForExport(rawmat: RawMaterialDto): EntityRawMaterialsDtoExtended {
    return this.checkedRawMaterialsForExport.find(value => value.entityCode === rawmat.entity.identifier);
  }

  /**
   * Manage the selection and the unselection of the rows
   *
   * @param rows Line of the table
   */
  broadcastSelectedRows(rows: RawMaterialDto[]) {
    this.checkedRawMaterials = [];
    this.checkedRawMaterialsForExport = [];
    this.checkedRawMaterialIds = [] ;
    this.checkedMultiModificationRm = [];
    if (rows && rows.length > 0) {
      this.checkedMultiModificationRm = rows;
      for(const row of rows) {
        this.onRawMaterialCheckboxChangeForCalcBatch(row);
        this.onRawMaterialCheckboxChangeForExport(row);
      }
    }
  }

  /**
   * Processes the action passed in the emitter according to its type, applies it to the line passed as a parameter
   *
   * @param actionOnRow Object containing the row and the type of action to perform on it.
   */
  treatAction(actionOnRow: ActionTableEvent) {
    if (actionOnRow) {
      switch (actionOnRow.type) {
        case PrimengTableComponent.editAction:
          this.goInput(actionOnRow.row.id);
          break;
        case PrimengTableComponent.enableAction:
          this.enabled(actionOnRow.row);
          break;
        case PrimengTableComponent.disableAction:
          this.disabled(actionOnRow.row);
          break;
        case PrimengTableComponent.archiveAction:
          this.archived(actionOnRow.row);
          break;
        case PrimengTableComponent.desarchiveAction:
          this.desarchived(actionOnRow.row);
          break;
        case PrimengTableComponent.duplicateAction:
          this.duplicate(actionOnRow.row);
          break;
        default:
          this.delete(actionOnRow.row);
      }
      this.primengTableService.setActionEvent(null);
    }
  }

  onRawMaterialCheckboxChangeForCalcBatch(rawmat: RawMaterialDto) {
    const entityCode = rawmat.entity.identifier;
    const entityToCalcBatch = this.getCheckedRawMaterialsByEntityCodeForCalcBatch(rawmat);
    // add rawmaterial to list to calculate batch
    if (FunctionUtils.isDefined(entityToCalcBatch)) {
      entityToCalcBatch.rmCodes.push({
        rmCode: rawmat.code,
        rmLabel: rawmat.label
      });
    } else {
      const rmCodes: RawMaterialCodeDtoExtended[] = [{
        rmCode: rawmat.code,
        rmLabel: rawmat.label
      }];
      this.checkedRawMaterials.push({entityCode: entityCode, rmCodes: rmCodes});
      this.entitySubService.getByCode(entityCode).subscribe(entity => {
        // set label of entity asynchronously
        const exportFound = this.checkedRawMaterials.find(expEntity => expEntity.entityCode === entityCode);
        exportFound.entityLabel = entity.name;
      });
    }
    // add raw material from list to calculate batch
    this.checkedRawMaterialIds.push(rawmat.id);
  }

  onRawMaterialCheckboxChangeForExport(rawmat: RawMaterialDto) {
    const rmBlockedBefore = CalculationStatusService.isCalcStatusBlockedBeforeCalc(rawmat.calculationStatus);
    const rmBlockedAfter = CalculationStatusService.isCalcStatusBlockedAfterCalc(rawmat.calculationStatus);
    /* If raw mat blocked then do not update anything */
    if (rmBlockedAfter || rmBlockedBefore) {
      return ;
    }
    const entityCode = rawmat.entity.identifier;
    const exportEntity = this.getCheckedRawMaterialsByEntityCodeForExport(rawmat);
    // add rawmaterial to list to export
    if (FunctionUtils.isDefined(exportEntity)) {
      exportEntity.rmCodes.push({
        rmCode: rawmat.code,
        rmLabel: rawmat.label
      });
    } else {
      const rmCodes: RawMaterialCodeDtoExtended[] = [{
        rmCode: rawmat.code,
        rmLabel: rawmat.label
      }];
      this.checkedRawMaterialsForExport.push({entityCode: entityCode, rmCodes: rmCodes}) ;
      this.entitySubService.getByCode(entityCode).subscribe(entity => {
        // set label of entity asynchronously
        const exportFound = this.checkedRawMaterialsForExport.find(expEntity => expEntity.entityCode === entityCode);
        exportFound.entityLabel = entity.name;
      });
    }
  }

  openImportFullAuto(forCreation: boolean): void {
    this.dialogMat.open(RawmaterialsImportFullAutoPopin, {
      width: "50vw",
      data: {
        creationMode: forCreation
      }
    }).afterClosed().subscribe((isImportStarted) => {
      if(isImportStarted){
        this.importFullAutoCheck();
      }
    });
  }

  onOpenImportFullAutoCreation(): void {
    this.openImportFullAuto(true);
  }

  onOpenImportFullAutoModification(): void {
    this.openImportFullAuto(false);
  }

  /**
   * check no same raw material code between entities
   */
  private hasSameRawMaterialCodeBetweenEntities(): boolean {
    // only one entity so return immediately
    if (!this.checkedRawMaterialsForExport || this.checkedRawMaterialsForExport.length <= 1) {
      return false;
    }

    const rawMatCodes: string[] = [];

    for (const value of this.checkedRawMaterialsForExport) {
      if (value?.rmCodes?.length > 0) {

        for (const rmCode of value.rmCodes) {
          if (rawMatCodes.includes(rmCode.rmCode)) {
            this.toastService.toast(this.translate.instant('msg.user.raw-material.same-code', {code: rmCode.rmCode}));
            return true;
          }
          rawMatCodes.push(rmCode.rmCode);
        }
      }
    }
    return false;
  }

  calculateBatch() {
    if (this.jobId !== '') {
      this.toastService.toast(this.translate.instant('msg.user.calculate-batch.already-one'));
      return;
    }
    if (!this.canCalculateBatch()) {
      return;
    }
    const confirmationMessage = this.translate.instant('label.user.calculate.confirmation.multiple');
    const dialog = this.dialogMat.open(NeqRawMaterialsConfirmationPopinComponent, {
      data: {
        message: confirmationMessage,
        rawMaterials: this.checkedRawMaterials
      }
    });
    dialog.afterClosed().subscribe(result => {
      if (result) {
        this.entityService.rawMaterialscalculateBatchCreate(
          this.userService.getEntity(),
          Constants.JOB_TYPE_CALCULATE_BATCH,
          this.checkedRawMaterialIds
        ).subscribe((response) => {
          this.userService.addJob(response, Constants.JOB_TYPE_CALCULATE_BATCH);
          this.toastService.toast(this.translate.instant('label.user.calculate-batch.launched'));
        });
      }
    });
  }

  exportRequest() {
    if (!this.canExport()) {
      return;
    }

    if (this.hasSameRawMaterialCodeBetweenEntities()) {
      return;
    }

    if (this.hasToManyRawMaterialsToExport()) {
      return;
    }

    const confirmationMessage = this.translate.instant('label.user.export.confirmation.multiple');
    const dialog = this.dialogMat.open(RawmaterialsExportDialogComponent, {
      data: {
        message: confirmationMessage,
        rawMaterials: this.checkedRawMaterialsForExport,
        defaultFormat: this.userService.getEntityDto().rawmatExportFormat,
        listFormat: this.userService.getEntityDto().rawmatExportList
      }
    });
    dialog.afterClosed().subscribe((optionnalFormatChose) => {
      if (optionnalFormatChose) {
        // add default format to the optionnal format list
        optionnalFormatChose.push(this.userService.getEntityDto().rawmatExportFormat);

        const request: ExportMultiFormatRequestDto = {
          refreshToken: 'DEPRECATED',
          rawMaterialsCodes: this.checkedRawMaterialsForExport,
          exportFormatList: optionnalFormatChose
        };

        this.entityService.rawMaterialsexportnotificationExportMultiFormatNotification(this.userService.getEntity(), request)
          .subscribe(() => {
            this.toastService.toast(this.translate.instant('label.user.export.request-successful'));
          });
      }
    });
  }

  refreshTable = async (request: NeqTableRequest) => {
    const neqTableData = new NeqTableData<RawMaterialDtoExtend>();
    const results = await this.refresh(request);

    this.headerService.setHeaderValues({
      strongLabel: results==null ?'0' : '' + results.total,
      basicLabel: this.translate.instant('label.common.rawmaterials'),
      showLogo: true
    });

    if (this.importSemiAutoIsOnGoing) {
      const rmToProcess = this.importSemiautoStore.getRmsToProcessValue()
      for(const d of results.data) {
        const rm = rmToProcess.find(r => d.id == r.rawMaterial.id)
        if (rm) {
          const de = d as RawMaterialDtoExtend;
          de.lineNumber = rm.lineNumber;
          de.isImportMode = true;
        }
      }
    }

    if(results != null) {
      neqTableData.results = results.data as RawMaterialDtoExtend[];
      neqTableData.totalElements = results.total;
      neqTableData.pageIndex = request.pageIndex;
      neqTableData.paginate = true;
    }
    this.rawmaterials = neqTableData.results;
    return neqTableData;
  };


  lockErrorMessage(){
    this.dialogService.showErrorSimpleOneMessage(this.translate.instant('error.rawmaterial.locked'));
    this.table.fireRefresh();
    return EMPTY;
  }


  delete(rawMat: RawMaterialDto) {
    const msg = this.translate.instant(
      'label.user.rawmaterial.delete.confirmation', {param: rawMat.code + ' - ' + rawMat.label});
    const dialog = this.dialogService.showConfirmation(msg);

    dialog.afterClosed().subscribe(result => {
      if (result) {
        this.rawMatService.get(this.userService.getEntity(), rawMat.id).pipe(catchError(() => {
          return this.lockErrorMessage();
        })).subscribe(rawmaterial => {
          if(rawMat.status == rawmaterial.status){
            this.rawMatService.delete(this.userService.getEntity(), rawMat.id)
              .pipe(catchError(() => {
                  return this.lockErrorMessage();
                })).subscribe(() => {
                  this.toastService.toast(this.translate.instant('msg.user.rawmaterial.deleted'));
                  this.table.fireRefresh();
                });
          } else {
            this.dialogService.showErrorSimpleOneMessage(this.translate.instant('error.rawmaterial.locked'));
            this.table.fireRefresh();
          }
        });
      }
    });
  }

  duplicate(rawMat: RawMaterialDto): void {
    this.store.setProductIdToDuplicate(rawMat.id) ;
    /* Use relative path to make it easy to configure the go back button header
     * in the raw material property page */
    this.router.navigate([ 'duplicate'], { relativeTo: this.route }) ;
  }

  disabled(rawMat: RawMaterialDto) {
    this.rawMatService.get(this.userService.getEntity(), rawMat.id).pipe(catchError(() => {
      return this.lockErrorMessage();
    })).subscribe(rawmaterial => {
      if(rawMat.status == rawmaterial.status){
        rawMat.status = RawmaterialOrSampleStatus.DISABLED;
        this.saveChangeStatus(rawMat, 'msg.user.rawmaterial.disabled');
      } else {
        this.dialogService.showErrorSimpleOneMessage(this.translate.instant('error.rawmaterial.locked'));
        this.table.fireRefresh();
      }
    });
  }

  enabled(rawMat: RawMaterialDto) {
    this.rawMatService.get(this.userService.getEntity(), rawMat.id).pipe(catchError(() => {
      return this.lockErrorMessage();
    })).subscribe(rawmaterial => {
      if(rawMat.status == rawmaterial.status){
        rawMat.status = RawmaterialOrSampleStatus.ENABLED;
        this.saveChangeStatus(rawMat, 'msg.user.rawmaterial.enabled');
      } else{
        this.dialogService.showErrorSimpleOneMessage(this.translate.instant('error.rawmaterial.locked'));
        this.table.fireRefresh();
      }
    });
  }

  archived(rawMat: RawMaterialDto) {
    const msg = this.translate.instant(
      'label.user.rawmaterial.archive.confirmation', {param: rawMat.code + ' - ' + rawMat.label});
    const asiDialog = this.dialogService.showConfirmation(msg);
    asiDialog.afterClosed().subscribe((result: boolean) => {
      if (!result) {
        return ;
      }
      this.rawMatService.get(this.userService.getEntity(), rawMat.id).pipe(catchError(() => {
        return this.lockErrorMessage();
      })).subscribe(rawmaterial => {
        if(rawMat.status == rawmaterial.status){
          rawMat.status = RawmaterialOrSampleStatus.ARCHIVED;
          this.saveChangeStatus(rawMat, 'msg.user.rawmaterial.archived');
        } else {
          this.dialogService.showErrorSimpleOneMessage(this.translate.instant('error.rawmaterial.locked'));
          this.table.fireRefresh();
        }
      });
    });
  }

  desarchived(rawMat : RawMaterialDto) {
    this.rawMatService.get(this.userService.getEntity(), rawMat.id).pipe(catchError(() => {
      return this.lockErrorMessage();
    })).subscribe(rawmaterial => {
      if(rawMat.status == rawmaterial.status) {
        rawMat.status = RawmaterialOrSampleStatus.DISABLED;
        this.saveChangeStatus(rawMat, 'msg.user.rawmaterial.desarchive');
      } else {
        this.dialogService.showErrorSimpleOneMessage(this.translate.instant('error.rawmaterial.locked'));
        this.table.fireRefresh();
      }
    });
  }

  saveChangeStatus(rawMat: RawMaterialDto, keyMessage: string) {
    this.rawMatService.changeStatus(this.userService.getEntity(), rawMat)
      .pipe(catchError(() => {
        return this.lockErrorMessage();
      })).subscribe(() => {
        this.toastService.toast(this.translate.instant(keyMessage));
        this.table.fireRefresh();
      });
  }

  goEditing(id: string) {
    this.router.navigate([`/app/rawmaterials/edit/${id}`]);
  }

  /**
   * Show the edit page of the current row
   *
   * @param id id of the nutrient
   */
  goInput(id: string) {
    this.router.navigate([`/app/rawmaterials/input/${id}`]);
  }

  leaveAdvancedSearchResult() {
    this.router.navigate(['/app/rawmaterials']);
  }

  canBeDeleted(rawmaterialDto: RawMaterialDto) {
    const isLocked = RawMaterialOrSampleUtil.isLocked(rawmaterialDto);
    return !isLocked ||
                (
                  isLocked &&
                  rawmaterialDto.status === RawmaterialOrSampleStatus.DISABLED
                );
  }

  isEnabled(rawmaterialDto: RawMaterialDto) {
    return rawmaterialDto.status === RawmaterialOrSampleStatus.ENABLED;
  }

  isArchived(rawmaterialDto: RawMaterialDto) {
    return rawmaterialDto.status === RawmaterialOrSampleStatus.ARCHIVED;
  }

  isDesarchived(rawmaterialDto: RawMaterialDto) {
    return rawmaterialDto.status === RawmaterialOrSampleStatus.DISABLED;
  }

  canBeEnabled(rawmaterialDto: RawMaterialDto) {
    return rawmaterialDto.status === RawmaterialOrSampleStatus.DISABLED;
  }

  // This method is used as a callback in the context of the table.
  // It is not possible to access the methods of the NeqRawmaterialsListPage class
  // (so no access to the semiauto context for example).
  calculateRowCssClass(rawmaterialDto: RawMaterialDtoExtend) {
    // calcul de date rawmaterialDto.calculationDate
    // disabled first !
    if (rawmaterialDto.status === RawmaterialOrSampleStatus.DISABLED) {
      return 'disabled-bkg-color';
    }
    if (rawmaterialDto.isImportMode && rawmaterialDto.calculationDate != null) {
      const yesterday = Date.now() - 86400000;
      // rawmaterialDto.calculationDate after yesterday
      if (rawmaterialDto.calculationDate > yesterday) {
        return 'recent-update';
      }
    }
    return '';
  }

  isAdvancedSearchResult(): boolean {
    return this.advancedSearchFilters !== undefined && (!!this.advancedSearchFilters['levelId'] || !!this.advancedSearchFilters['predictionModelId']
      || !!this.advancedSearchFilters['referenceId']);
  }

  displayArchivedRawMaterials() {
    this.displayArchivedRawMat = !this.displayArchivedRawMat;
    sessionStorage.setItem('RAW_MAT_ARCHIVED_STATE', String(this.displayArchivedRawMat));
    this.refreshFilters();
  }

  displayDisabledRawMaterials() {
      this.displayDisabledRawMat = !this.displayDisabledRawMat;
      sessionStorage.setItem('RAW_MAT_DISABLED_STATE', String(this.displayDisabledRawMat));

      if (this.table) {
        this.table.fireRefresh();
      } else {
        this.refreshFilters();
      }
    }

  displayRMWaitingForCalculation() {
    this.displayWaitingForCalculationRM = !this.displayWaitingForCalculationRM;
    this.refreshFilters();
  }

  private returnDefaultFilter(request: NeqTableRequest): RawMaterialFilterDto {
    const filters = new RawMaterialFilterDto();
    filters.page = request.pageIndex;
    filters.count = request.nbElementsParPage;
    if (request.filters) {
      for(const child of request.filters) {
        switch (child.key) {
          case 'code':
            filters.code = child.value;
            break;
          case 'label':
            filters.label = child.value;
            break;
          case 'referenceLabel':
            filters.reference = child.value;
            break;
          case 'referencePredictionModelLabel':
            filters.predictionModel = child.value;
            break;
          case 'calculationBy':
            filters.calculationBy = child.value;
            break;
          case 'calculationDate':
            filters.startCalculation = FunctionUtils.convertDateToIsoFormat(child.value[0]);
            filters.endCalculation = FunctionUtils.convertDateToIsoFormat(child.value[1]);
            break;
          case 'entityLabel':
            filters.entityLabel = child.value;
            break;
        }
      }
    }
    return filters;
  }

  private refresh(request: NeqTableRequest) {
    if (this.importSemiAutoIsOnGoing) {
      return this.refreshForSemiAuto(request)
    } else {
      return this.refreshForRawMat(request)
    }
  }

  private refreshForSemiAuto(request: NeqTableRequest) {
    const filters = this.returnDefaultFilter(request);
    const rmsToProcess = this.importSemiautoStore.getRmsToProcessValue();
    if (rmsToProcess != null && !rmsToProcess.isEmpty()) {
      filters.ids = rmsToProcess
        .filter(r => { return r.rawMaterial.id != null; })
        .map(r => {
          return r.rawMaterial.id;
        }).toArray();
    }
    if (filters.ids == null || filters.ids.length == 0) {
      const r: SharedPagedResponse<RawMaterialDto> = new SharedPagedResponse<RawMaterialDto>();
      r.data = [];
      r.total = 0
      return lastValueFrom(of(r));
    }
    return lastValueFrom(this.rawMatService.fetch(this.userService.getEntity(), filters));
  }

  private refreshForRawMat(request: NeqTableRequest) {
    const filters = this.returnDefaultFilter(request);
    if (this.advancedSearchFilters) {
      if (this.advancedSearchFilters['levelId']) {
        filters.levelId = this.advancedSearchFilters['levelId'];
      }
      if (this.advancedSearchFilters['predictionModelId']) {
        filters.predictionModelId = this.advancedSearchFilters['predictionModelId'];
      }
      if (this.advancedSearchFilters['referenceId']) {
        filters.referenceId = this.advancedSearchFilters['referenceId'];
      }
    }
    /* If not defined it takes the false value (which is the default value) */
    filters.archive = this.displayArchivedRawMat ?? false;
    filters.disabled = this.displayDisabledRawMat ?? false;
    filters.waitingForCalculation = this.displayWaitingForCalculationRM ?? false;
    // Save current sort
    this.currentSort = this.getSort(request);
    filters.sort = this.currentSort;

    return lastValueFrom(this.rawMatService.fetch(this.userService.getEntity(), filters));
  }

  /**
   * Call the reset of the filter and State of the table
   */
  resetFilter() {
      this.displayArchivedRawMat = false;
      this.displayDisabledRawMat = false;
      sessionStorage.removeItem('RAW_MAT_ARCHIVED_STATE');
      sessionStorage.removeItem('RAW_MAT_DISABLED_STATE');

      this.primengTableService.setResetTableEvent(this.RAW_MAT_LIST_SESSION_ID);

      this.showTable = false;
      setTimeout(() => {
        this.showTable = true;
      }, 0);
    }

  startImportCreateSemiauto(): void {
    this.importSemiautoStore.setImportMode(SemiautoImportMode.CREATION);
    this.dialogMat.open(RawmaterialsImportSemiAutoPopinComponent, { width: "50vw" });
  }

  startImportModifySemiauto(): void {
    this.importSemiautoStore.setImportMode(SemiautoImportMode.MODIFICATION);
    this.dialogMat.open(RawmaterialsImportSemiAutoPopinComponent, { width: "50vw" });
  }

  /**
   * Check if number of exported Raw materials is less or equals than the export limit
   * @returns true if is greater than limit
   */
  private hasToManyRawMaterialsToExport() {
    if (this.checkedRawMaterialIds.length > this.userService.getEntityDto().limitExport) {
      this.toastService.toast(this.translate.instant('label.user.export.error.limit-export', {param: this.userService.getEntityDto().limitExport}));
      return true;
    }
    return false;
  }

  // Multi modification
  onClickMultiselection(): void {
    this.rmMultiModificationStore.start(this.checkedMultiModificationRm);
  }

  /**
   * Check if the multi selection of modification can be clicked
   *
   * @returns true if the multiselection can be clicked
   */
  canUseMultiselection(): boolean {
    return this.checkedMultiModificationRm.length > 1;
  }

  private importFullAutoCheck() {
    this.importAutoCheckInterval = setInterval(()=> { this.importFullAutoCheckInterval() }, 1000);
  }

  private importFullAutoCheckInterval(){
    if (!this.jobIdImport || this.jobIdImport === '') {
      clearInterval(this.importAutoCheckInterval);
      this.table.fireRefresh();
    }
  }
}

export class EntityRawMaterialsDtoExtended extends EntityRawMaterialsDto {
  entityLabel?: string;
  rmCodes: RawMaterialCodeDtoExtended[];
}

export class RawMaterialCodeDtoExtended extends ExportRawMaterialCodeDto {
  rmCode: string;
  rmLabel: string;
}

export class RawMaterialDtoExtend extends RawMaterialDto {
  lineNumber?: number;
  isImportMode: boolean;
}

export function splittedFetchData(filter, rawMaterialsId, rawMatService, userServiceGetEntity){
  let promisesList = [];
  for (let i = 0; i < rawMaterialsId.length; i = i+100){
      let splittedRawMaterialsId = rawMaterialsId.slice(i, Math.min(i+100, rawMaterialsId.length));
      filter.ids = splittedRawMaterialsId;
      promisesList.push(rawMatService.fetch(userServiceGetEntity, filter).toPromise());
  }
  return Promise.all(promisesList).then((results) => {
      return results.reduce((acc, current) => {
          acc.data = [...acc.data, ...current.data];
          acc.scrollId += current.scrollId;
          acc.total += current.total;
          return acc;
      });
  });
}

export function lockingRawMaterials(rawMaterialsId, locking, entityService, userServiceGetEntity){
  let patchAction = locking ? 'LOCK_ENTITY' : 'UNLOCK_ENTITY'

  let promisesList = [];
    for (let i = 0; i < rawMaterialsId.length; i = i+100){
        let splittedRawMaterialsId = rawMaterialsId.slice(i, Math.min(i+100, rawMaterialsId.length));
        promisesList.push(entityService.patch(userServiceGetEntity, {patchAction: patchAction, rawMatIds: splittedRawMaterialsId}).toPromise());
    }
    return promisesList;
}
